import {
  canZoomIn,
  canZoomOut,
  stepZoom,
  ZOOM_FIT,
  zoomPercentLabel,
} from './depthChartZoom';

interface Props {
  zoom: number;
  onChange: (zoom: number) => void;
}

/**
 * Zoom out / readout / zoom in, plus a reset back to the width-filling default.
 *
 * Real <button>s rather than styled divs, so they are focusable and operable from the keyboard
 * without any extra wiring. The readout is aria-live so a screen reader announces the new level
 * instead of leaving the change silent.
 */
export const DepthChartZoomControl = ({ zoom, onChange }: Props) => (
  <div
    className="depth-chart-zoom-control"
    role="group"
    aria-label="Depth chart zoom"
    data-testid="depth-chart-zoom"
  >
    <button
      type="button"
      className="depth-chart-zoom-control__button"
      onClick={() => onChange(stepZoom(zoom, 'out'))}
      disabled={!canZoomOut(zoom)}
      aria-label="Zoom out"
    >
      &minus;
    </button>
    <button
      type="button"
      className="depth-chart-zoom-control__readout"
      onClick={() => onChange(ZOOM_FIT)}
      disabled={zoom === ZOOM_FIT}
      // The readout doubles as reset: it is the only control whose label already states what
      // clicking it goes back to, and a separate third button for one click is clutter.
      title="Reset zoom to fit the width"
    >
      <span aria-live="polite">{zoomPercentLabel(zoom)}</span>
    </button>
    <button
      type="button"
      className="depth-chart-zoom-control__button"
      onClick={() => onChange(stepZoom(zoom, 'in'))}
      disabled={!canZoomIn(zoom)}
      aria-label="Zoom in"
    >
      +
    </button>
  </div>
);
